import { useEffect } from 'react';

const useDisableScroll = (): void => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
};

export default useDisableScroll;
